<template>
  <div class="m-card">
    <div class="m-card__header">
      <div class="title-c">{{ title }}</div>
      <div class="icon-c" v-if="action" >
        <router-link :to="url">
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M6.67981 13.6608C6.57743 13.5529 6.49606 13.4246 6.44034 13.2833C6.38462 13.142 6.35565 12.9904 6.35507 12.8372C6.3545 12.684 6.38234 12.5321 6.437 12.3903C6.49166 12.2486 6.57207 12.1196 6.67364 12.0109L10.2636 8.1664L1.09786 8.1664C0.806693 8.1664 0.527448 8.0435 0.321558 7.82473C0.115669 7.60596 9.35902e-07 7.30925 9.79178e-07 6.99987C1.02246e-06 6.69048 0.115669 6.39377 0.321559 6.175C0.527448 5.95623 0.806693 5.83333 1.09786 5.83333L10.2636 5.83333L6.67364 1.98887C6.46854 1.76902 6.35405 1.4716 6.35533 1.16204C6.35662 0.852487 6.47359 0.556152 6.6805 0.33823C6.88741 0.120308 7.16732 -0.00135402 7.45866 1.35966e-05C7.74999 0.00138121 8.02888 0.125664 8.23397 0.34552L13.6814 6.17819C13.8855 6.39669 14 6.69204 14 6.99987C14 7.30769 13.8855 7.60304 13.6814 7.82155L8.23397 13.6542C8.1324 13.7632 8.0116 13.8499 7.87848 13.9092C7.74536 13.9685 7.60253 13.9994 7.45817 14C7.31381 14.0006 7.17076 13.971 7.0372 13.9127C6.90364 13.8545 6.78219 13.7689 6.67981 13.6608Z"
              fill="#27884D"
            />
          </svg>
        </router-link>
      </div>
    </div>
    <div class="m-card__main">
      <div class="letter">{{ data }} <span v-if="name !== 'ratio'">%</span></div>
      <div v-if="tag !== null">
        <div class="tag-number" :class="tag.color">{{ tag.copy }}</div>
      </div>
    </div>
    <div v-if="copyFooter !== null">
      <div class="m-card__footer" :class="copyFooter.color">
        <div>{{ copyFooter.copy }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {},
    number: {},
    title: {},
    name: {},
    action: {
      type: Boolean,
      default: false
    },
    url: {},
  },
  watch: {
    tag() {
      this.$emit('addColor', this.tag);
    },
  },
  computed: {
    tag() {
      switch (this.name) {
        case "cancelations":
          return this.infoCancelations !== null ? this.infoCancelations.warning : null;
        case "ratio":
          return this.infoRatio !== null ? this.infoRatio.warning : null;
        case "availability":
          return this.infoAvailability !== null ? this.infoAvailability.warning : null;
        case "tardies":
          return this.infoTardies !== null ? this.infoTardies.warning : null;
        default:
          return "";
      }
    },
    copyFooter() {
      switch (this.name) {
        case "cancelations":
          return this.infoCancelations !== null ? this.infoCancelations.motivation : null;
        case "ratio":
          return this.infoRatio !== null ? this.infoRatio.motivation : null;
        case "availability":
          return this.infoAvailability !== null ? this.infoAvailability.motivation : null;
        case "tardies":
          return this.infoTardies !== null ? this.infoTardies.motivation : null;
        default:
          return "";
      }
    },
    infoCancelations() {
      switch (true) {
        case this.data < 2:
          return {
            warning: {
              color: "gray",
              copy: "Sobre el promedio: < 2%"
            },
            motivation: {
              color: "green",
              copy: "Continúa así"
            }
          };
        case this.data >= 2 && this.data <= 7:
          return {
            warning: {
              color: "orange",
              copy: "Por debajo del promedio: 2% a 7%"
            },
            motivation: {
              color: "orange",
              copy: "Necesita mejora"
            }
          };
        case this.data > 7:
          return {
            warning: {
              color: "red",
              copy: "Necesita atención urgente: 7%"
            },
            motivation: {
              color: "red",
              copy: "Afecta tu evaluación"
            }
          };
        default:
          return null;
      }
    },
    infoRatio() {
      switch (true) {
        case this.data > 4.5:
          return {
            warning: {
              color: "gray",
              copy: "Sobre el promedio: > 4.5"
            },
            motivation: {
              color: "green",
              copy: "Continúa así"
            }
          };
        case this.data >= 3.5 && this.data <= 4.5:
          return {
            warning: {
              color: "orange",
              copy: "Por debajo del promedio: 3.5 a 4.5"
            },
            motivation: {
              color: "orange",
              copy: "Necesita mejora"
            }
          };
        case this.data < 3.5:
          return {
            warning: {
              color: "red",
              copy: "Necesita atención urgente: < 3.5"
            },
            motivation: {
              color: "red",
              copy: "Afecta tu evaluación"
            }
          };
        default:
          return null;
      }
    },
    infoAvailability() {
      switch (true) {
        case this.data > 80:
          return {
            warning: {
              color: "gray",
              copy: "Sobre el promedio: > 80%"
            },
            motivation: {
              color: "green",
              copy: "Continúa así"
            }
          };
        case this.data >= 60 && this.data <= 80:
          return {
            warning: {
              color: "orange",
              copy: "Por debajo del promedio: 60% a 80%"
            },
            motivation: {
              color: "orange",
              copy: "Necesita mejora urgente"
            }
          };
        case this.data < 60:
          return {
            warning: {
              color: "red",
              copy: "Necesita atención urgente: < 60%"
            },
            motivation: {
              color: "red",
              copy: "Afecta tu evaluación"
            }
          };
        default:
          return null;
      }
    },
    infoTardies() {
      switch (true) {
        case this.data < 10:
          return {
            warning: {
              color: "gray",
              copy: "Sobre el promedio: < 10%"
            },
            motivation: {
              color: "green",
              copy: "Continúa así"
            }
          };
        case this.data >= 10 && this.data <= 30:
          return {
            warning: {
              color: "orange",
              copy: "Por debajo del promedio: 10% a 30%"
            },
            motivation: {
              color: "orange",
              copy: "Necesita mejora urgente"
            }
          };
        case this.data > 30:
          return {
            warning: {
              color: "red",
              copy: "Necesita atención urgente: > 30%"
            },
            motivation: {
              color: "red",
              copy: "Afecta tu evaluación"
            }
          };
        default:
          return null;
      }
    },
  }
};
</script>
